import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Breadcrumbs from "@/components/vr/Breadcrumbs";
import Seo, { breadcrumbLd } from "@/components/vr/Seo";
import { Play, Youtube } from "lucide-react";

export function VideosList() {
  const [videos, setVideos] = useState([]);
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/videos?limit=100").then((r) => setVideos(r.data));
    api.get("/settings/public").then((r) => setSettings(r.data || {}));
  }, []);
  return (
    <div className="vr-container my-8">
      <Seo
        title="YouTube Classes — Bihar Board Video Lectures (Hindi)"
        description="Faiz Sir के साथ बिहार बोर्ड कक्षा 9-12 के लिए Chapter-wise YouTube video lectures — हिन्दी में।"
        canonical="/youtube"
        jsonLd={breadcrumbLd([{ name: "Home", url: "/" }, { name: "YouTube Classes", url: "/youtube" }])}
      />
      <Breadcrumbs items={[{ label: "YouTube Classes" }]} />
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display font-extrabold text-3xl text-[#0F172A]">YouTube Classes</h1>
          <p className="text-slate-600 mt-1 font-hindi">Faiz Sir के साथ Bihar Board की सम्पूर्ण तैयारी।</p>
        </div>
        {settings.youtube_channel_url && (
          <a href={settings.youtube_channel_url} target="_blank" rel="noreferrer" className="vr-btn-red" data-testid="visit-channel-btn"><Youtube size={16} /> Visit Channel</a>
        )}
      </div>
      <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {videos.map((v) => (
          <a key={v.id} href={`https://youtu.be/${v.youtube_id}`} target="_blank" rel="noreferrer" className="vr-card overflow-hidden group" data-testid={`video-${v.id}`}>
            <div className="relative aspect-video bg-slate-100">
              <img loading="lazy" src={`https://i.ytimg.com/vi/${v.youtube_id}/hqdefault.jpg`} alt={`${v.title} — YouTube video by VR Classes`} className="w-full h-full object-cover" />
              <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/40 transition">
                <div className="w-12 h-12 rounded-full bg-[#DC2626] flex items-center justify-center opacity-0 group-hover:opacity-100"><Play className="text-white" size={22} /></div>
              </div>
            </div>
            <div className="p-4">
              <h2 className="font-semibold text-[#0F172A] line-clamp-2 text-base">{v.title}</h2>
              <div className="mt-1 text-xs text-slate-500">{v.class_slug?.replace("class-", "Class ")} · {v.subject_slug}</div>
              {v.description && <div className="mt-1 text-sm text-slate-600 line-clamp-2">{v.description}</div>}
            </div>
          </a>
        ))}
        {videos.length === 0 && <div className="text-slate-500 text-sm col-span-3">जल्द ही videos अपलोड होंगे।</div>}
      </div>
    </div>
  );
}
